import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./assets/styles/style.css";
import Navbar from "./components/Navbar";
import Addpage from "./pages/Addpage";
import Editpage from "./pages/Editpage";
import Home from "./pages/Home";

function App() {
  return (
    <Router>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/addbook" element={<Addpage />} />
        <Route path="/edit/:id" element={<Editpage />} />
      </Routes>
    </Router>
  );
}

export default App;
